package com.dotdrives.repository

import com.dotdrives.client.ConfigurationClient
import com.dotdrives.model.*
import com.dotdrives.model.Target

interface ConfigurationRepository {
    suspend fun load(org: String): Result<ConfigurationSnapshot>

    suspend fun target(value: Target): Result<Unit>

    suspend fun phase(value: DrivePhase): Result<Unit>

    suspend fun template(value: DrivePhaseTemplate): Result<Unit>
}

class SupabaseConfigurationRepository(
    private val client: ConfigurationClient = ConfigurationClient(),
    private val targetsOnly: Boolean = false,
) : ConfigurationRepository {
    override suspend fun load(org: String) = runCatching { client.load(org, targetsOnly) }

    override suspend fun target(value: Target) = runCatching { client.target(value) }

    override suspend fun phase(value: DrivePhase) = runCatching { client.phase(value) }

    override suspend fun template(value: DrivePhaseTemplate) = runCatching {
        client.template(value)
    }
}
